import React from 'react';
import {TripBoardsModalApolloProvider} from '@homeaway/react-trip-board-button';
import Experiment from '@homeaway/react-experiment';
import {HA_IDA_LOGIN_TO_SAVE_TRIPBOARD} from '../../abacus/experiments';
import LoginExperience from '../LoginExperience/LoginExperience';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';

export default function TripBoardsProviderContainer({
    actionLocation,
    siteName,
    isLoggedIn,
    locale,
    brand,
    setUserLoggedIn,
    adultsCount,
    childrenCount,
    endDate,
    petIncluded,
    startDate
}) {
    const tripBoardProviderParams = {
        adultsCount,
        childrenCount,
        endDate,
        petIncluded,
        startDate
    };

    return (
        <Experiment name={HA_IDA_LOGIN_TO_SAVE_TRIPBOARD} deferLogging>
            {({On, Off}) => (
                <React.Fragment>
                    <ErrorBoundary label="TripBoardsModalReduxProvider">
                        <On>
                            <TripBoardsModalApolloProvider
                                actionLocation={actionLocation}
                                siteName={siteName}
                                {...tripBoardProviderParams}
                                isLoggedIn={isLoggedIn}
                                autosave
                                showCoachmark
                                {...!isLoggedIn && {
                                    renderInitialModal: (onComplete, onClose, isOpen) =>
                                        isOpen && (
                                            <LoginExperience
                                                modalMode
                                                locale={locale}
                                                actionLocation="heartButtonLogin"
                                                site={siteName}
                                                siteName={brand}
                                                onClose={onClose}
                                                onSuccess={onComplete}
                                                context="savetripboard"
                                                setUserLoggedIn={setUserLoggedIn}
                                            />
                                        )
                                }}
                            />
                        </On>
                        <Off>
                            <TripBoardsModalApolloProvider
                                actionLocation={actionLocation}
                                siteName={siteName}
                                {...tripBoardProviderParams}
                                isLoggedIn={isLoggedIn}
                                autosave
                                showCoachmark
                            />
                        </Off>
                    </ErrorBoundary>
                </React.Fragment>
            )}
        </Experiment>
    );
}
